/* eslint-disable object-curly-newline */
import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

const Link = styled.a`
  cursor: pointer;
`;

const DownloadPdf = ({ className, href, download, children }) => (
  <Link className={className} href={href} download={download}>
    { children }
  </Link>
);

DownloadPdf.propTypes = {
  href: PropTypes.string,
  download: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.any.isRequired,
};

DownloadPdf.defaultProps = {
  href: '/downloads/Familien_und_Flucht_aus_der_DDR.pdf',
  download: 'Familien und Flucht aus der DDR.pdf',
  className: undefined,
};

export default DownloadPdf;



// WEBPACK FOOTER //
// ./src/components/DownloadPdf/DownloadPdf.js